import { render } from "./QuestionForm.vue?vue&type=template&id=b3b8b9c4&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"

import "./QuestionForm.vue?vue&type=style&index=0&id=b3b8b9c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b8b9c4"]])

export default __exports__